<dls-reset>
  <ng-container *ngIf="router.url === '/login'; else dashboardContent">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-template #dashboardContent>
    <mat-toolbar class="toolbar">
      <!-- Left Part: Menu Icon + Title -->
      <div class="left-part">
        <button mat-icon-button aria-label="Menu icon" (click)="toggleMenu()">
          <mat-icon>menu</mat-icon>
        </button>
        <h1 class="toolbar-title">BREASE PLATFORM PROTOTYPE UI</h1>
      </div>

      <!-- Right Part: User Menu -->
      <div class="right-part">
        <span class="user-details">AMPM User</span>
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="User menu">
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #menu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item (click)="signout()">
            <mat-icon>exit_to_app</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <mat-sidenav-container autosize="true">
      <!-- Move middle-part here -->
      <div class="middle-part">
        <section class="pt-navigation-context">
          <dls-tabs class="pt-primary-navigation">
              <a routerLink="/tasks"
                  routerLinkActive="pt-selected"
                  ><span>Tasks</span>
              </a>
              <a routerLink="/patient-search/pms" routerLinkActive="pt-selected" [routerLinkActiveOptions]="{ exact: true }">
                  <span>Patients</span>
              </a>
              <a routerLink="/report" routerLinkActive="pt-selected">
                <span>Reports and templates</span>
            </a>
            <a routerLink="/admin" routerLinkActive="pt-selected">
              <span>Administration</span>
          </a>
          </dls-tabs>
        </section>
      </div>
      <mat-sidenav
      [ngClass]="!isCollapsed ? 'expanded' : ''"
      [mode]="isMobile ? 'over' : 'side'"
      [opened]="isMobile ? false : true"
      [style.width]="isCollapsed ? '64px' : '254px'">
      <mat-nav-list>
        <a mat-list-item [routerLink]="'/dashboard'" routerLinkActive="active">
          <span class="entry">
            <mat-icon>home</mat-icon>
            <span *ngIf="!isCollapsed">Dashboard</span>
          </span>
        </a>
        <a mat-list-item [routerLink]="'/tasks'" routerLinkActive="active">
          <span class="entry">
            <mat-icon>check_circle</mat-icon>
            <span *ngIf="!isCollapsed">Tasks</span>
          </span>
        </a>
        <a mat-list-item [routerLink]="'/patient-search/pms'" routerLinkActive="active">
          <span class="entry">
            <mat-icon>people</mat-icon>
            <span *ngIf="!isCollapsed">Patients</span>
          </span>
        </a>
        <a mat-list-item [routerLink]="'/report'" routerLinkActive="active">
          <span class="entry">
            <mat-icon>description</mat-icon>
            <span *ngIf="!isCollapsed">Reports & Templates</span>
          </span>
        </a>
        <a mat-list-item [routerLink]="'/admin'" routerLinkActive="active">
          <span class="entry">
            <mat-icon>admin_panel_settings</mat-icon>
            <span *ngIf="!isCollapsed">Administration</span>
          </span>
        </a>
      </mat-nav-list>
      <div class="bottom-nav-actions">
        <mat-divider></mat-divider>
        <a mat-list-item [routerLink]="'/settings'" routerLinkActive="active">
          <span class="entry">
            <mat-icon>settings</mat-icon>
            <span *ngIf="!isCollapsed">Settings</span>
          </span>
        </a>
        <a mat-list-item [routerLink]="'/help'" routerLinkActive="active">
          <span class="entry">
            <mat-icon>help_outline</mat-icon>
            <span *ngIf="!isCollapsed">Help</span>
          </span>
        </a>
      </div>
      <style>
        .menu-spacer {
          display: none;
        }
        mat-sidenav {
          display: flex;
          flex-direction: column;
          height: 100%;
          overflow: hidden; /* Ensure no scroll on sidenav */
        }
        mat-nav-list {
          display: flex;
          flex-direction: column;
          flex: 1 1 auto;
          /* height: 100%;  Remove this line */
          overflow: visible; /* Let it inherit from sidenav */
        }
        .bottom-nav-actions {
          margin-top: 18rem;
          display: flex;
          flex-direction: column;
          align-items: stretch;
        }
      </style>
      </mat-sidenav>
      <mat-sidenav-content
      [style.marginLeft]="isCollapsed ? '64px' : '254px'">
      <app-loader *ngIf="isLoading"></app-loader>
      <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </ng-template>
</dls-reset>
